import Vue from 'vue'
import { notification, NOTIFICATION_TYPES } from '@/utils/errors'

export default {
    async send (context, {
        title = '', text = '', type, duration = 3000, group = 'global',
    }) {
        Vue.notify({
            type,
            group,
            title,
            text,
            duration,
        })
    },
    async sendInfo (context, {
        title = '', text = '', duration = 3000, group = 'global',
    }) {
        Vue.notify({
            type: NOTIFICATION_TYPES.info,
            group,
            title,
            text,
            duration,
        })
    },
    async sendWarning (context, {
        title = '', text = '', duration = 3000, group = 'global',
    }) {
        Vue.notify({
            type: NOTIFICATION_TYPES.warning,
            group,
            title,
            text,
            duration,
        })
    },
    async sendError (context, {
        title = '', text = '', duration = 3000, group = 'global',
    }) {
        Vue.notify({
            type: NOTIFICATION_TYPES.error,
            group,
            title,
            text,
            duration,
        })
    },
    async sendSuccess (context, {
        title = '', text = '', duration = 3000, group = 'global',
    }) {
        Vue.notify({
            type: NOTIFICATION_TYPES.success,
            group,
            title,
            text,
            duration,
        })
    },
    // Manage http error and send notification
    async error ({ dispatch }, {
        status, data, duration = 3000, group = 'global',
    }) {
        Vue.notify({
            ...notification({
                status, data, duration, group,
            }),
        })
    },
}
